"use client";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectValue,
  SelectItem,
} from "@/components/ui/select";
import useStore from "@/lib/state";

const RED_GUM_BUTTON_COLORS = {
  background: "#892102",
  foreground: "#FFFFFF",
};

export function TimePeriodFilter() {
  const { selectedTimePeriod, setSelectedTimePeriod } = useStore();

  const timePeriods = [
    { value: "All", label: "All" },
    { value: "Morning", label: "Morning" },
    { value: "Afternoon", label: "Afternoon" },
    { value: "Nightshift", label: "Evening" },
  ];

  return (
    <>
      {/* Desktop - Buttons */}
      <div className="hidden gap-2 lg:flex">
        {timePeriods.map((period) => (
          <Button
            key={period.value}
            variant={selectedTimePeriod === period.value ? "default" : "outline"}
            size="sm"
            customColors={RED_GUM_BUTTON_COLORS}
            onClick={() => setSelectedTimePeriod(period.value)}
            className="whitespace-nowrap"
          >
            {period.label}
          </Button>
        ))}
      </div>

      {/* Mobile - Dropdown */}
      <div className="lg:hidden">
        <Select
          value={selectedTimePeriod}
          onValueChange={(value) => setSelectedTimePeriod(value)}
        >
          <SelectTrigger className="w-full p-5">
            <SelectValue placeholder="Time Period" />
          </SelectTrigger>
          <SelectContent>
            {timePeriods.map((period) => (
              <SelectItem key={period.value} value={period.value}>
                {period.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
}

